import React from "react";
import { SvgIcon } from "@material-ui/core";

// Ícone dos agentes de IA (menu "Agentes de IA", IA digitando, selo do agente
// na lista de chamados). O @material-ui/icons 4 não tem robô; o AndroidIcon
// do sistema marca o Chatbot, que é outra coisa.
const RobotIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect x="6" y="8" width="12" height="10" rx="2" />
    <circle cx="10" cy="13" r="1.2" fill="currentColor" />
    <circle cx="14" cy="13" r="1.2" fill="currentColor" />
    <rect x="10.5" y="4" width="3" height="2" rx="0.5" />
    <rect x="11.25" y="6" width="1.5" height="2" rx="0.5" />
    <rect x="4" y="10.5" width="2" height="5" rx="1" />
    <rect x="18" y="10.5" width="2" height="5" rx="1" />
    <rect x="10" y="16" width="4" height="1.5" rx="0.75" fill="currentColor" />
  </SvgIcon>
);

export default RobotIcon;
